import { styled } from 'stitches.config'

export const QuantityInput = styled('input', {
  border: 'none',
  appearance: 'none',
  width: '$6',
  backgroundColor: '$tertiary-100',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  borderRadius: '$2',
  color: '$tertiary-900',
  fontSize: '$body',
  fontWeight: '$medium',

  variants: {
    size: {
      tiny: {
        height: '$4',
      },
      small: {
        height: '$5',
      },
      regular: {
        height: '$6',
      },
    },
  },

  defaultVariants: {
    size: 'tiny',
  },
})
